// Import Day.js and required plugins
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from "dayjs/plugin/isBetween";
import metaData from '../data/metaData';

// Extend Day.js with the plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

// Set the default timezone for the app
dayjs.tz.setDefault(metaData.timezone); // Change to your desired timezone

// Custom function to create Day.js instances in the default timezone
const timezonedDayjs = (...args) => {
    return dayjs(...args).tz();
};

// Extend the custom Day.js with additional functionality
timezonedDayjs.unix = (value) => {
    return dayjs.unix(value).tz();
};

// Export the custom timezonedDayjs
export default timezonedDayjs;
